module.exports = __webpack_public_path__ + "media/images/icons/cogs-4205035bdbb6ad0f8625c6d3c3a3c936.svg";